<template>
  <!-- 主路由内容 -->
  <div v-if="isMainRoute" class="company-main-layout">
    <!-- 使用Banner组件 -->
    <Banner :banner-list="bannerList" :accordion-items="accordionItems" />
  </div>
  
  <!-- 子路由内容 -->
  <div v-else class="layout-container">
    <div class="sidebar">
      <el-menu
        :router="true"
        :default-active="normalizedRoutePath"
      >
        <el-menu-item index="/company/introduction">
          {{ t('pages.company.introduction.title') }}
        </el-menu-item>
        <el-menu-item index="/company/dream">
          {{ t('pages.company.dream.title') }}
        </el-menu-item>
        <el-menu-item index="/company/events">
          {{ t('pages.company.events.title') }}
        </el-menu-item>
        <el-menu-item index="/company/partners">
          {{ t('pages.company.partners.title') }}
        </el-menu-item>
        <el-menu-item index="/company/honors">
          {{ t('pages.company.honors.title') }}
        </el-menu-item>
        <el-menu-item index="/company/structure">
          {{ t('pages.company.structure.title') }}
        </el-menu-item>
      </el-menu>
    </div>
    <div class="content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import { computed, ref } from 'vue';
import Banner from '@/components/Home/Banner.vue';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const normalizedRoutePath = computed(() => {
  return route.path.replace(/^\/(zh|en)(?=\/|$)/i, '') || '/'
});

// 判断是否是主路由
const isMainRoute = computed(() => {
  return normalizedRoutePath.value === '/company' || normalizedRoutePath.value === '/company/';
});

// 导航到子路由
const navigateTo = (path: string) => {
  router.push(path);
};

// 配置Banner组件的banner列表
const bannerList = ref([
  {
    image: '/images/homebanner/Banner01.jpg',
    title: '关于公司',
    titleAnimation: 'fade-in-down',
    descAnimation: 'fade-in-up'
  },
 
]);

// 配置AccordionSection组件的内容项
const accordionItems = ref([
  {
    title: 'home.company.items.introduction.title',
    content: '',
    image: '/images/AccordionSection.jpg',
    link: '/company/introduction'
  },
  {
    title: 'home.company.items.dream.title',
    content: '',
    image: '/images/AccordionSection.jpg',
    link: '/company/dream'
  },
  {
    title: 'home.company.items.chronicle.title',
    content: '',
    image: '/images/AccordionSection.jpg',
    link: '/company/events'
  }, 
  {
    title: 'home.company.items.partners.title',
    content: '',
    image: '/images/AccordionSection.jpg',
    link: '/company/partners'
  },
  {
    title: 'home.company.items.honors.title',
    content: '',
    image: '/images/AccordionSection.jpg',
    link: '/company/honors'
  },
  {
    title: 'home.company.items.structure.title',
    content: '',
    image: '/images/AccordionSection.jpg',
    link: '/company/structure'
  }
]);

const companySections = [
  {title:'pages.company.introduction.title',
    
    path: '/company/introduction'
  },
  {
    title: 'pages.company.dream.title',

    path: '/company/dream'
  },
  {
    title: 'pages.company.events.title',
  
    path: '/company/events'
  },
  {
    title: 'pages.company.partners.title',

    path: '/company/partners'
  },
  {
    title: 'pages.company.honors.title',
    path: '/company/honors'
  }
];
</script>

<style scoped lang="scss">
// 子路由布局样式
.layout-container {
  display: flex;
  padding: 100px 40px 40px;
  max-width: 1400px;
  margin: 0 auto;
  gap: 40px;

  .sidebar {
    width: 280px;
    flex-shrink: 0;
  }

  .content {
    flex: 1;
    min-width: 0;
  }
}

// 主路由布局样式
.company-main-layout {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

@media screen and (max-width: 768px) {
  .layout-container {
    flex-direction: column;
    padding: 80px 20px 20px;
    gap: 20px;
    align-items: center;

    .sidebar {
      display: none;
    }

    .content {
      width: 100%;
      max-width: 800px;
      text-align: center;
    }
  }
}
</style> 
